<template>
    <DCard
        padding
    >
        <DTable
            :items="dhpExtensions"
            :fields="fields"
            hover
            sorter
        >
            <template #price="{item}">
                <td>
                    {{ priceFormat.priceFormatForDisplayInCurrency(item.price, DHP_CURRENCY) }}
                </td>
            </template>
            <template #price_period="{item}">
                <td>
                    {{ item.price_period }} {{ __('settings.dhp_extensions.table.data.' + (item.price_period_unit === '' ? 'Day(s)' : item.price_period_unit)) }}
                </td>
            </template>
            <template #contract_term="{item}">
                <td>
                    {{ item.contract_term }} {{ __('settings.dhp_extensions.table.data.' + (item.price_period_unit === '' ? 'Day(s)' : item.price_period_unit)) }}
                </td>
            </template>
            <template #description="{item}">
                <td>
                    {{ item.description ?? '' }}
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <div style="display: flex; grid-gap: 10px">
                        <DButton
                            :id="`edit_${item.extension}`"
                            mini
                            icon="pencil"
                            @click="editDhpExtensions(item.id)"
                        />
                    </div>
                </td>
            </template>
        </DTable>
    </DCard>
    <DFabs>
        <DFab
            id="btn-add"
            icon="plus"
            :label="__('settings.dhp_extensions.add_extension')"
            @click="$inertia.get($route('settings.dhp-extensions.create'))"
        />
    </DFabs>
</template>

<script setup>
import { ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'
import priceFormat from '~@/Composables/priceFormat'

// DHP extensions are sold in a single market region whose currency is EUR, so the price is not
// derived from the tenant currency setting or from a market region.
const DHP_CURRENCY = 'EUR'

const fields = ref([
    { key: 'id', label: __('settings.dhp_extensions.table.headers.id'), sorter: true },
    { key: 'extension', label: __('settings.dhp_extensions.table.headers.extension'), sorter: true },
    { key: 'group', label: __('settings.dhp_extensions.table.headers.group'), sorter: true },
    { key: 'price', label: __('settings.dhp_extensions.table.headers.price'), sorter: false },
    { key: 'price_period', label: __('settings.dhp_extensions.table.headers.price_period'), sorter: false },
    { key: 'contract_term', label: __('settings.dhp_extensions.table.headers.contract_term'), sorter: false },
    { key: 'description', label: __('settings.dhp_extensions.table.headers.description'), sorter: false },
    { key: 'actions', label: '', sorter: false }
])

defineProps({
    dhpExtensions: {
        type: Array,
        default: () => {
            return []
        }
    }
})
function editDhpExtensions (dhpExtension) {
    return router.get(route('settings.dhp-extensions.edit', { dhp_extension: dhpExtension }))
}

</script>

<style scoped lang="scss">

</style>
